import React from 'react';
import type { SVGPropsWithClassName } from './types';
import { colors } from '@/styles';
import { isColorName } from '@/styles/colorUtils';

export const RadioHeartUnselect = ({
  className = '',
  size = 16,
  title = 'Unselect',
  fill = colors.silverSandAlt,
}: SVGPropsWithClassName) => {
  const height = Number(size) * 2.85;

  let svgFill = fill;
  if (isColorName(fill)) {
    console.warn('Using deprecated fill prop for RadioHeartUnselect, fill should be a hex.');
    svgFill = colors[fill];
  }

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 30 28.185"
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M61.972,138.334l-2.69-2.443c-1.166-1.059-2.335-2.12-3.493-3.191a58.926,58.926,0,0,
1-4.76-4.824,21.274,21.274,0,0,1-2.665-3.763,11.4,11.4,0,0,
1-1.25-3.615c-.05-.308-.093-.636-.113-.964l0-1.19.033-.144a8.336,8.336,0,0,1,
.529-2.355,8.585,8.585,0,0,1,
7.083-5.611c.241-.034.528-.055.8-.076l.59-.009c.409.026.695.048.98.088a9.468,
9.468,0,0,1,5,2.266l.187-.163a9.2,9.2,0,0,1,4.8-2.089c.272-.038.569-.06.866-.081l.633,
0,.2.033c.193.028.354.045.516.064a8.543,8.543,0,0,1,7.65,7.255L77,118.537l-.036,1.272a10.942,
10.942,0,0,1-.823,3.308,17.827,17.827,0,0,1-2.68,4.217,39.861,39.861,0,0,
1-3.622,3.856q-3.326,3.012-6.591,
6.02c-.086.088-.23.215-.375.34Zm-12.4-19.713v.83c.012.16.046.4.083.627a8.849,8.849,
0,0,0,.963,2.79,18.623,18.623,0,0,0,2.341,3.3,56.3,56.3,0,0,0,4.566,4.626c1.164,1.076,
2.328,2.133,3.486,3.187l.97.884c2.046-1.884,4.071-3.734,6.108-5.577a37.292,37.292,0,0,
0,3.388-3.612,15.335,15.335,0,0,0,2.3-3.6A8.254,8.254,0,0,0,74.4,119.5l.015-.873-.1-.725a6.058,
6.058,0,0,0-4.63-4.961,5.923,5.923,0,0,
0-.76-.113c-.163-.021-.328-.038-.49-.062l-.476-.019c-.146.014-.383.029-.617.064a6.62,6.62,
0,0,0-3.479,1.5c-.175.15-.349.316-.524.485-.162.153-.323.308-.493.461l-.911.815-1.006-1.016a6.9,
6.9,0,0,0-4.265-2.261c-.241-.036-.468-.05-.695-.067l-.344,0c-.213.015-.438.031-.65.062a6.035,
6.035,0,0,0-5,3.957,5.785,5.785,0,0,0-.383,1.721Z
`}
        transform="translate(-46.997 -110.15)"
        fill={svgFill}
      />
    </svg>
  );
};
